/** 创作者中心 */
export const creatorCenter = [
  {
    name: 'getCreatorCenterOverview', // 创作者中心数据
    isMock: false,
  },
  {
    name: 'getAICreateData', //ai创作数据及趋势图
    isMock: false,
  },
  {
    name: 'getSquareArtworkRank', //用户广场作品榜单
    isMock: false,
  },
  {
    name: 'getFollowingStats', // 粉丝数据及趋势图
    isMock: false,
  },
  {
    name: 'getActiveFansStats', // 用户的活跃粉丝
    isMock: false,
  },
]
